export default __webpack_public_path__ + "static/media/meal3.20b4954d.jpg";